"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDropRender = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Button_1 = __importDefault(require("../Button/Button"));
var react_dropzone_1 = __importDefault(require("react-dropzone"));
var InputLabel_1 = __importDefault(require("../InputLabel/InputLabel"));
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var FileDropRender = /** @class */ (function (_super) {
    __extends(FileDropRender, _super);
    function FileDropRender(props) {
        var _this = _super.call(this, props) || this;
        _this.onUpload = function (valid, invalid) {
            var _a = _this.props, t = _a.t, onAccepted = _a.onAccepted, onRejected = _a.onRejected;
            if (valid.length) {
                var message = void 0;
                if (valid.length === 1) {
                    message = valid[0].name + " (" + _this.formatBytes(valid[0].size) + ") " + t('Added');
                }
                else {
                    message = valid.length + " " + t('Files Added');
                }
                _this.setState({ successMessage: message, inDrag: false, invalidDrop: false }, function () {
                    return onAccepted && onAccepted(valid);
                });
            }
            if (invalid.length) {
                _this.setState({ successMessage: null, invalidDrop: true, inDrag: false }, function () {
                    return onRejected && onRejected(invalid);
                });
            }
        };
        _this.resetDrop = function (e) {
            e.preventDefault();
            _this.setState({ successMessage: null, invalidDrop: false }, function () {
                return _this.props.onReset && _this.props.onReset();
            });
        };
        _this.state = {
            inDrag: false,
            invalidDrop: false,
            successMessage: null
        };
        return _this;
    }
    FileDropRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, disabled = _a.disabled, buttonText = _a.buttonText, className = _a.className, error = _a.error, indicator = _a.indicator, onAccepted = _a.onAccepted, onRejected = _a.onRejected, onReset = _a.onReset, placeholder = _a.placeholder, acceptedTypes = _a.acceptedTypes, maxSize = _a.maxSize, multiple = _a.multiple, resetButtonText = _a.resetButtonText, t = _a.t, lng = _a.lng, rest = __rest(_a, ["label", "disabled", "buttonText", "className", "error", "indicator", "onAccepted", "onRejected", "onReset", "placeholder", "acceptedTypes", "maxSize", "multiple", "resetButtonText", "t", "lng"]);
        return (React.createElement("div", __assign({}, rest, { className: this.genClasses() }),
            label ? React.createElement(InputLabel_1.default, { label: label, indicator: indicator }) : null,
            React.createElement(react_dropzone_1.default, { ref: function (ref) { return _this.dropzoneRef = ref; }, disableClick: true, disabled: disabled, accept: acceptedTypes, className: "drop-zone", multiple: multiple, onDragOver: function () { return _this.setState({ inDrag: true }); }, onDragLeave: function () { return _this.setState({ inDrag: false }); }, onDrop: function (accepted, rejected) { return _this.onUpload(accepted, rejected); }, maxSize: maxSize },
                React.createElement("div", { className: "drop-display-content" }, this.renderContent()))));
    };
    FileDropRender.prototype.genClasses = function () {
        var classes = 'ui file-drop';
        var _a = this.props, className = _a.className, error = _a.error;
        var _b = this.state, inDrag = _b.inDrag, successMessage = _b.successMessage, invalidDrop = _b.invalidDrop;
        if (className) {
            classes += ' ' + className;
        }
        if (inDrag) {
            classes += ' on-drag';
        }
        if (successMessage) {
            classes += ' populated';
        }
        if (invalidDrop || error) {
            classes += ' error';
        }
        return classes;
    };
    FileDropRender.prototype.browseFiles = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, disabled = _a.disabled, buttonText = _a.buttonText, t = _a.t;
        return (React.createElement("div", { className: "browse-files" },
            React.createElement("div", { className: "drop-zone-msg" }, placeholder ? placeholder : t('Drop a file to upload')),
            React.createElement("div", { className: "drop-zone-msg" }, t('Or')),
            React.createElement(Button_1.default, { type: "inline-secondary", className: "upload-button", disabled: disabled, content: buttonText ? buttonText : t('Browse Files'), onClick: function (e) {
                    e.preventDefault();
                    _this.dropzoneRef.open();
                } })));
    };
    FileDropRender.prototype.renderContent = function () {
        var _this = this;
        var _a = this.props, error = _a.error, resetButtonText = _a.resetButtonText, t = _a.t;
        var _b = this.state, invalidDrop = _b.invalidDrop, successMessage = _b.successMessage;
        if (invalidDrop || error) {
            return (React.createElement(React.Fragment, null,
                this.browseFiles(),
                React.createElement("div", { className: "error-msg" }, error ? error : t('One or more files were not accepted')),
                invalidDrop || successMessage
                    ? React.createElement(Button_1.default, { type: "inline-secondary", className: "upload-button reset-file-button", content: resetButtonText ? resetButtonText : t('Reset File'), onClick: function (e) { return _this.resetDrop(e); } })
                    : null));
        }
        else if (successMessage) {
            return (React.createElement(React.Fragment, null,
                this.browseFiles(),
                React.createElement(Icon_1.default, { root: "common", name: "check", className: "success-icon" }),
                React.createElement("div", { className: "drop-zone-msg" }, successMessage),
                React.createElement(Button_1.default, { type: "inline-secondary", className: "upload-button", content: resetButtonText ? resetButtonText : t('Reset File'), onClick: function (e) { return _this.resetDrop(e); } })));
        }
        else {
            return this.browseFiles();
        }
    };
    FileDropRender.prototype.formatBytes = function (bytes, decimals) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var dm = decimals || 2;
        var k = 1024;
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };
    return FileDropRender;
}(react_1.Component));
exports.FileDropRender = FileDropRender;
exports.default = localization_1.InjectLocalization(FileDropRender);
